module.exports = __webpack_public_path__ + "static/img/patho-missing-eardrum-jgPhTLo9.2194c718.png";